// extracted by mini-css-extract-plugin
module.exports = {"licenses":"styles_licenses__1QsnV","accordionItem":"styles_accordionItem__3n2kD","body":"styles_body__kBmjA"};